/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */


/**
 * Computed tag source type
 * * COMPUTED
 * * KPI
 */
export enum ComputedSource {
  COMPUTED = 'COMPUTED',
  KPI = 'KPI'
}
